module.exports = __webpack_public_path__ + "img/iconUp.1aee04d7.svg";